import { ref } from 'vue';

const getWagetypes = () => {
    const wagetypes_error = ref(null);
    const wagetypes = ref(null);

    const loadWagetypes = async () => {

        try {
            let data = await fetch("/api/wagetypes");

            if (!data.ok) {
                throw Error("Can't load data");
            }

            wagetypes.value = await data.json();
            console.log('Wagetypes', wagetypes.value);
        } catch (err) {
            wagetypes_error.value = err.message;
        }
    };

    const saveWagetype = async (wagetypeId, worktypeIds, externalIds) => {

        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: wagetypeId,
                worktypes: worktypeIds,
                external_ids: externalIds
            })
        };

        try {
            const response = await fetch('/api/wagetypes/' + wagetypeId, requestOptions);
            //console.log(requestOptions);
            if (!response.ok) {
                //console.log(response.status + ' - ' + response.statusText);
                wagetypes_error.value = response.status + ' - ' + response.statusText;
            }
            const data = await response.text();

        } catch (err) {
            wagetypes_error.value = err.message;
            console.log(err.message);
        }

    };

    return { wagetypes, wagetypes_error, loadWagetypes, saveWagetype };
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export default getWagetypes;
